<template>
  <validation-observer ref="simpleRules">
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="12"
        >
          <title-configs-text />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <address-configs-text />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <configs-phone />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <configs-whatsapp />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <email-configs-text />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <menu-view-select-configs-card />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <menu-color-select-configs-card />
        </b-col>
      </b-row>
    </b-card>
    <b-button
      variant="primary"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </validation-observer>
</template>

<script>
import {
  BCard, BButton, BRow, BCol,
} from 'bootstrap-vue'

import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import TitleConfigsText from '@/views/Configs/Elements/TitleText.vue'
import AddressConfigsText from '@/views/Configs/Elements/AddressText.vue'
import ConfigsPhone from '@/views/Configs/Elements/PhoneCard.vue'
import ConfigsWhatsapp from '@/views/Configs/Elements/WhatsappCard.vue'
import EmailConfigsText from '@/views/Configs/Elements/EmailCard.vue'
import MenuViewSelectConfigsCard from '@/views/Configs/Elements/MenuViewCard.vue'
import MenuColorSelectConfigsCard from '@/views/Configs/Elements/MenuColorCard.vue'

export default {
  name: 'Index',
  components: {
    MenuColorSelectConfigsCard,
    MenuViewSelectConfigsCard,
    EmailConfigsText,
    ConfigsWhatsapp,
    ConfigsPhone,
    AddressConfigsText,
    TitleConfigsText,
    ValidationObserver,
    BCard,
    BButton,
    BRow,
    BCol,
  },
  data() {
    return {
      required,
      imageUrl: this.$store.state.app.baseURL,
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['configs/dataItem']
    },
    saveData() {
      return this.$store.getters['configs/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getData()
    },
  },
  created() {
    localize('tr')
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('configs/getDataItem')
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          // eslint-disable-next-line
          this.$store.dispatch('configs/saveData',this.itemData)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
